import type { ApiResponse } from '~/types';
import type { UserInfo, UserLogin } from '~/types/User';
import type { NitroFetchRequest, $Fetch } from 'nitropack'
export const userRepository = () => ({
    async getUserInfo() {
        return await useAPIFetch<ApiResponse<UserInfo>>('/sso/info')
    },

    async login(username: string, password: string) {
        return await useAPIFetch<ApiResponse<UserLogin>>('/sso/login', {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                username,
                password,
            }).toString(),
            method: 'POST',
        })
    },

    async register(email?: string, password?: string, telephone?: string, firebaseToken?: string) {
        const bodyParams: Record<string, string> = {};

        if (email) bodyParams.email = email;
        if (password) bodyParams.password = password;
        if (telephone) bodyParams.telephone = telephone;
        if (firebaseToken) bodyParams.firebaseToken = firebaseToken;

        return await useAPIFetch<ApiResponse<UserLogin>>('/sso/v1/register', {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            method: 'POST',
            body: new URLSearchParams(bodyParams).toString(),
        })
    },

    async updateUser(user: UserInfo) {
        return await useAPIFetch<ApiResponse<number>>('/sso/update', {
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(user),
            method: 'POST',
        })
    },
});
